import {Component, Inject, OnInit} from '@angular/core';
import {DialogService} from "../shared/dialog/dialog.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormGroupManager} from "../shared/cml-forms/form-factory.service";
import {DialogComunicationService} from "../shared/dialog/dialog-comunication.service";
import {ValidationService} from "../shared/cml-forms/validation.service";
import {DialogComponentData} from "../shared/dialog/interfaces";
import {FormDialogComponent} from "../shared/dialog/form-dialog/form-dialog.component";

@Component({
    selector: 'cml-cro-registration-form-dialog-service',
    templateUrl: '../shared/dialog/form-dialog/form-dialog.component.html',
    styleUrls: ['../shared/dialog/form-dialog/form-dialog.component.scss'],
    standalone: false
})
export class CroRegistrationFormDialogServiceComponent extends FormDialogComponent {
  constructor(dialogService: DialogService,
              dialogRef: MatDialogRef<CroRegistrationFormDialogServiceComponent>,
              formManager: FormGroupManager,
              dialogComunicationService: DialogComunicationService,
              validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public override data: DialogComponentData)
  {
    super(dialogRef,data , dialogService, formManager, dialogComunicationService, validationService);
  }

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.form.controls["newPasswordRepeat"].disable()

    this.form.controls["newPassword"].valueChanges.subscribe(() =>{
      this.form.controls["newPassword"].value ? this.form.controls["newPasswordRepeat"].enable() :  this.form.controls["newPasswordRepeat"].disable()
    })

    this.form.controls["newPasswordRepeat"].valueChanges.subscribe(() =>{
      this.validatePassword()
    })
  }

  async validatePassword(){
    let firstPass = this.form.controls["newPassword"].value
    let secondPass = this.form.controls["newPasswordRepeat"].value
    if(firstPass != secondPass){
      this.form.controls["newPasswordRepeat"].setErrors({passwordNotEquals: true})
    }
  }
}
